import { useSession } from "next-auth/react";
import { useEffect } from "react";
import { useStore } from "store";
import { useGetMyActiveData } from "./cartHooks";

export const useFreshData = () => {
    const hasFreshData = useStore((state) => state.data.hasFreshData);
    const setHasFreshData = useStore((state) => state.setHasFreshData);
    const { data: session, status } = useSession();

    const executeGetMyActiveData = useGetMyActiveData();

    const fetchActiveData = async () => {
        if (!session) {
            return;
        }
        await executeGetMyActiveData();
    };

    useEffect(() => {
        // We can't get a session if next-auth is still loading
        // We can't load active data if the user is anonymous
        if (status !== "authenticated") {
            return;
        }
        if (!hasFreshData) {
            fetchActiveData();

            setHasFreshData(true);
        }
    }, [status, hasFreshData, fetchActiveData, executeGetMyActiveData]);
};

export default useFreshData;
